/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Norwegian (Norway): no-no
 */

/**
 * Translation file for no-NO locale
 *
 * @file no.js
 * @author Mohamed yasar arabath M
 */

const no = {
  'common.OK': 'Ok',
  'common.CONTINUE': 'Fortsett',
  'browser.check.DONT_SHOW_AGAIN': 'Don\'t show me this again',
  'browser.check.SYS_REQUIREMENTS_LINK_TEXT': 'støttet operativsystem og nettleser',
  'browser.check.BROWSER_MESSAGE_TITLE': 'Nettleseren <<name>> er utdatert',
  'browser.check.BROWSER_MESSAGE_DESC': 'Bruk en ny versjon av nettleserne for å få best mulig opplevelse:',
  'browser.check.BROWSER_SKIP_NOW': 'Hopp over for denne gang',
  'browser.check.BROWSER_SUPPORTED_LINK_TEXT': 'Om støttede nettlesere',
  'browser.check.BROWSER_UNSUPPORTED_TITLE': 'Nettleseren <<name>> støttes ikke',
  'browser.check.BROWSER_UNSUPPORTED_DESC': 'Bruk en av de støttede nettleserne for å få best mulig opplevelse.',
  'browser.check.OS_UNSUPPORTED_TITLE': 'Operativsystemet <<name>> støttes ikke',
  'browser.check.OS_UNSUPPORTED_DESC': 'While the product may work with no issues, please be aware that any problems you encounter might be resolved by trying with a device running a <<link>>',
  'errors.GENERIC_TITLE': 'Serverfeil',
  'errors.GENERIC_DESC': 'Beklager, systemet vårt er nede. Prøv igjen senere eller ta kontakt med kundestøtte.',
  'errors.HTTP_400_TITLE': 'Serverfeil',
  'errors.HTTP_400_DESC': 'Det oppsto et problem under behandling av forespørselen din.',
  'errors.HTTP_401_TITLE': 'Er du logget inn?',
  'errors.HTTP_401_DESC': 'Vi kunne ikke hente dataene siden påloggingsøkten din kan være utløpt.',
  'errors.HTTP_403_TITLE': 'Uautorisert',
  'errors.HTTP_403_DESC': 'You don\'t have access to this resource.',
  'errors.HTTP_888_TITLE': 'Serveren var for treg til å svare',
  'errors.HTTP_888_DESC': 'Det oppsto et problem under behandling av forespørselen din.'
};

export default no;
